import React, { createContext, PropsWithChildren, useContext } from 'react'
import { PageProps } from 'gatsby'

export interface AppInfoInterface {
  appName: string
}

export interface AppInfo extends Partial<PageProps> {
  app: AppInfoInterface
}

export const AppContext = createContext<AppInfo | null>(null)

interface AppServiceProviderProps extends PropsWithChildren {
  appInfo: AppInfo
}

export const AppServiceProvider = ({ appInfo, children }: AppServiceProviderProps) => {
  return <AppContext.Provider value={appInfo}>{children}</AppContext.Provider>
}

export const useApp = () => {
  const context = useContext(AppContext)

  if (!context) {
    throw 'The App context has not been provided!'
  }

  return context
}
